import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { Tooltip, SnackBarHelper, Icon as IconComponent } from '@lyearn-team/frontend-components';
import $j from 'jquery';
import isURL from 'validator/lib/isURL';
import showVideoResponse from 'helper/uppy/videoUploader';

import { urlExists } from 'helper/urlExists';
import * as TinyPubSub from '../../../../../helper/TinyPubSub';
import { interactionsBlocked } from '../../../../../helper/blockUserInteractionHelper';

import Icon from '../../../../../helper/Icon';
import User from '../../../../../helper/currentUser';
import { uploadToS3 } from '../../../../helper/fileUpload';
import ReactMediaPlayer from '../../../../../components/ReactMediaPlayer/ReactMediaPlayer';
import ReactMediaPlayerPreview from '../../../../components/ReactMediaPlayer-AudioResponsePreview/ReactMediaPlayer';
import AudioResponseHelper from './AudioResponseHelper';
import { audioSineWave } from './AudioSineWave';

const user = new User();

@Radium
class AudioResponse extends React.Component {
  static propTypes = {
    response: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired
  };

  static contextTypes = {
    showTroublePopup: PropTypes.func,
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    checkForSubmit: PropTypes.func,
    getFeatureFlag: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.recordingTimer = '';
    this.defaultStates = {
      uploadError: false,
      recordingAudio: false,
      recordedAudio: null,
      responseToBeSubmitted: null,
      audioSubmissible: false,
      uploadAudioPreview: false,
      noAudioResponseSupport:
        window.location.protocol.indexOf('https') < 0 &&
        window.location.hostname.split('.')[0] !== 'localhost',
      noAudioSupport: true,
      uploadingAudio: false,
      showingPreviewAudio: false
    };

    this.state = Object.assign({}, this.defaultStates);
  }

  UNSAFE_componentWillMount() {
    this.state.audioAvailable = this.props.response && this.props.response.substr(0, 4) === 'http';
    this.audioResponseHelper = new AudioResponseHelper(this);
  }

  componentDidMount() {
    this.checkForLocalAudio(`${this.props.questionId}_${this.props.cardId}`);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.wavData = null;
      this.state = Object.assign({}, this.state, this.defaultStates);
      this.checkForLocalAudio(`${nextProps.questionId}_${nextProps.cardId}`);
    }
    this.state.audioAvailable = nextProps.response !== '';
  }

  componentWillUnmount() {
    TinyPubSub.unsubscribe('UserInteractionBlockChange');
    this.destroyAudioRecorder();
    this.cancelRecorded('UNMOUNT');
    this.recordingTimerChange(false);
  }

  emptySubmittedResponse = () => {
    this.audioBlobLocalStore('CLEAR');
    this.setState({ responseToBeSubmitted: null });
  };

  checkForLocalAudio = audioBlobRef => {
    const localAudio = this.audioBlobLocalStore(null, null, audioBlobRef);
    if (localAudio && typeof localAudio === 'object') {
      if (localAudio.audioState === 'RECORDED') {
        this.props.isResponseEntered && this.props.responseEnterChange(false);
        this.audioReady(null, null, localAudio.data);
      } else if (localAudio.audioState === 'UPLOADED') {
        this.doneUploadingAudio(localAudio.data, true);
      }
    }
  };

  audioBlobLocalStore = (audioBlobData, audioState, audioBlobRef) => {
    const audioBlobRefCode = audioBlobRef || `${this.props.questionId}_${this.props.cardId}`;
    if (audioBlobData === 'CLEAR') {
      window.recordedAudioBlobs[audioBlobRefCode] = null;
    } else if (audioBlobData) {
      window.recordedAudioBlobs[audioBlobRefCode] = { audioState, data: audioBlobData };
      return true;
    }

    return window.recordedAudioBlobs[audioBlobRefCode];
  };

  getResponse = () => {
    const response = this.props.deletingResponse
      ? ''
      : this.state.responseToBeSubmitted || this.props.response;
    return {
      questionObj: this.props.questionObj,
      responseData: {
        questionId: this.props.questionId,
        response,
        answerEvaluation: !response || response !== '' ? '' : 'NA',
        responseType: 'AUDIO',
        deletingResponse: this.props.deletingResponse
      },
      callBack: this.doneMutationAudio
    };
  };

  cancelFromSubmissionItem = () => {
    this.recordingTimerChange(false, true);
    this.cancelRecorded();
  };

  destroyAudioRecorder = () => {
    this.audioSineWave && this.audioSineWave.cancelDraw();
    this.audioResponseHelper && this.audioResponseHelper.destroy();
  };

  audioSupported = supported => {
    SnackBarHelper.showSnackbar({
      label: 'No Audio Support in your browser, Please grant access on browser prompt.',
      duration: 3
    });
    this.setState({
      noAudioSupport: !supported
    });
  };

  audioReady = (wavData, url, localAudioData) => {
    console.log('audio ready', wavData, url);
    this.wavData = wavData;
    window.analytics.track('RECORDED_AUDIO_READY_TO_UPLOAD', {
      card_name: this.props.cardName,
      card_id: this.props.cardId,
      question_index: this.props.position,
      time: Date(),
      type: 'audio'
    });
    if (localAudioData) {
      this.wavData = localAudioData.data;
      this.recordingTimerChange(false);
      this.setState({
        recordingAudio: false,
        recordedAudio: localAudioData.url,
        audioSubmissible: true,
        audioAvailable: true,
        showingPreviewAudio: true
      });
    } else {
      this.audioBlobLocalStore({ data: wavData, url }, 'RECORDED');
      this.setState({
        recordingAudio: false,
        recordedAudio: url,
        audioSubmissible: true,
        audioAvailable: true
      });
    }
  };

  uploadProgress = event => {
    if (event.lengthComputable && this.refs.progressBar) {
      this.refs.progressBar.max = event.total;
      this.refs.progressBar.value = event.loaded;
    }
  };

  doneUploadingAudio = (s3Url, localAudioAvailable) => {
    if (localAudioAvailable === true) {
      this.setState(
        {
          uploadingAudio: false,
          uploadSize: null,
          audioSubmissible: false,
          recordedAudio: null,
          responseToBeSubmitted: s3Url
        },
        () => this.context.checkForSubmit && this.context.checkForSubmit()
      );

      return false;
    }
    this.setState({
      uploadingAudio: false,
      uploadSize: null,
      audioSubmissible: false,
      recordedAudio: null
    });
    this.audioBlobLocalStore(s3Url, 'UPLOADED');
    this.props.responseEnterChange(true);
    return true;
  };

  doneMutationAudio = () => {
    this.audioBlobLocalStore('CLEAR');
    this.setState({
      showingPreviewAudio: false
    });
  };

  downloadRecordedAudio = audioBlobUrl => {
    if (audioBlobUrl) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = audioBlobUrl;
      a.download =
        'recorded_audio_' +
        this.props.card.globalPosition +
        '_' +
        this.props.cardName +
        '_' +
        new Date().getTime() +
        '.wav';
      a.click();
      a.parentNode.removeChild(a);
    }
  };

  submitAudio = () => {
    if (!this.state.audioSubmissible || this.state.recordingAudio) {
      return false;
    }
    this.setState({
      uploadingAudio: true,
      uploadSize: this.wavData.size,
      showingPreviewAudio: false
    });
    const audioBlobUrl = window.URL.createObjectURL(this.wavData);
    this.downloadRecordedAudio(audioBlobUrl);

    this.audioResponseHelper.submitAudio(
      this.props.position,
      this.props.questionId,
      this.props.editResponse,
      this.props.cardId,
      this.wavData,
      this.uploadProgress,
      this.doneUploadingAudio
    );
  };

  recordPressed = () => {
    analytics.track('RECORD', {
      card_name: this.props.cardName,
      card_id: this.props.cardId,
      question_index: this.props.position,
      time: Date(),
      type: 'audio'
    });

    if (this.state.noAudioResponseSupport) {
      return false;
    }

    this.audioResponseHelper.initiRecorder(() => {
      console.log('init callback !!', new Date().getTime());
      this.audioResponseHelper.recordAudio();
      this.setState({ recordingAudio: true });
      this.recordingTimerChange(true);
      this.audioSineWave = audioSineWave(
        this.audioResponseHelper,
        $j(`.audioRecorder${this.props.questionId} .visualizer`)
      );
    }, this.audioSupported);
  };

  recordingTimerChange = (start, reset) => {
    if (start === true && this.refs.recordingTimer) {
      console.log('start called', new Date().getTime());
      let totalSeconds = 0;
      this.refs.recordingTimer.innerHTML = '00:00';
      this.recordingTimer = setInterval(() => {
        if (this.refs.recordingTimer) {
          this.refs.recordingTimer.innerHTML = (() => {
            ++totalSeconds;
            let minute = Math.floor(totalSeconds / 60);
            minute = minute < 10 ? '0' + minute : minute;
            let seconds = totalSeconds - parseInt(minute, 10) * 60;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            return minute + ':' + seconds;
          })();
        }
      }, 1000);
    } else if (start === false) {
      if (reset && this.refs.recordingTimer) this.refs.recordingTimer.innerHTML = '00:00';
      clearInterval(this.recordingTimer);
    }
  };

  cancelRecorded = fromUnmount => {
    fromUnmount !== 'UNMOUNT' && this.audioBlobLocalStore('CLEAR');
    this.audioResponseHelper.stopRecording();
    this.audioResponseHelper.clearRecording();
    this.destroyAudioRecorder();
    this.audioSineWave && this.audioSineWave.cancelDraw();
    this.setState({
      uploadingAudio: false,
      recordedAudio: null,
      recordingAudio: false,
      audioSubmissible: false,
      showingPreviewAudio: false,
      uploadAudioPreview: false
    });
    this.recordingTimerChange(false, true);
  };

  renderPlayer = () => {
    const response = this.state.responseToBeSubmitted || this.props.response;
    const type = this.props.type;

    if (response && response.substr(0, 4) === 'http' && !this.state.recordedAudio) {
      let answerResponseExists = false;
      if (['FILE', 'IMAGE', 'VIDEO', 'AUDIO'].includes(type) && isURL(response)) {
        answerResponseExists = urlExists(response);
      } else {
        answerResponseExists = true;
      }
      return (
        <div style={styles.container} className="notUploadContainer">
          {!answerResponseExists && (
            <div style={styles.apologyContainer}>
              <IconComponent style={styles.alertIcon} type="alert" />
              This submission has been lost due to a technical error on our part. Apologies for the
              inconvinience caused!
            </div>
          )}
          <ReactMediaPlayer ref="ReactMediaPlayer" autoPlay={false} src={response} vendor="audio" />
        </div>
      );
    }
    if (this.state.uploadAudioPreview) {
      return (
        <div style={[styles.uploadedAudioContainer]} className="uploadContainer">
          <ReactMediaPlayer
            ref="ReactMediaPlayer"
            autoPlay={false}
            src={this.uploadedFileObjectUrl}
            vendor="audio"
          />
        </div>
      );
    }
    return null;
  };

  setRecordedAudioLength = totalSeconds => {
    this.refs.recordingTimer.innerHTML = (() => {
      let minute = Math.floor(totalSeconds / 60);
      minute = minute < 10 ? '0' + minute : minute;
      let seconds = totalSeconds - parseInt(minute, 10) * 60;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      return minute + ':' + seconds;
    })();
  };

  renderPreviewPlayer = () => {
    if (this.state.recordedAudio || this.state.responseToBeSubmitted) {
      const audioUrl = this.state.recordedAudio || this.state.responseToBeSubmitted;
      return (
        <div style={styles.miniPlayerContainer}>
          <ReactMediaPlayerPreview
            ref="ReactMediaPlayer"
            autoPlay={false}
            src={audioUrl}
            vendor="audio"
            onlySeekbar={true}
            controlsWrapperStyle={{ width: 'auto' }}
            cancelRecorded={this.cancelRecorded}
            audioLength={this.setRecordedAudioLength}
          />
        </div>
      );
    }
    return null;
  };

  doneRecord = () => {
    window.analytics.track('RECORD_STOPPED', {
      card_name: this.props.cardName,
      card_id: this.props.cardId,
      question_index: this.props.position,
      time: Date(),
      type: 'audio'
    });

    this.audioSineWave && this.audioSineWave.cancelDraw();
    this.audioResponseHelper.stopRecording();
    this.destroyAudioRecorder();

    this.audioResponseHelper.exportWAV(this.audioReady);

    this.recordingTimerChange(false);
  };

  createDownloadLink = () => {
    this.recorder && this.recorder.exportWAV(blob => {});
  };

  editAudio = () => {
    this.audioResponseHelper.initiRecorder(() => {
      this.setState({
        recordingAudio: true
      });
    }, this.audioSupported);

    if (!this.state.noAudioResponseSupport) {
      this.recordPressed();
    }
  };

  renderButtons = () => (
    <div style={styles.wrapper}>
      {this.show_InBoxButtons ? (
        <div style={styles.boxContainer}>
          {this.show_sineWave && (
            <canvas style={styles.canvasStyle} className="visualizer" width="400" height="100" />
          )}
          {this.renderInBoxButtons()}
        </div>
      ) : null}
      {this.renderOutBoxButtons()}
    </div>
  );

  renderStatusLabels = () =>
    (() => {
      if (this.state.recordingAudio) return 'Recording...';
      if (this.state.audioSubmissible && this.state.recordedAudio) return 'Stopped.';
      return '';
    })();

  renderInBoxButtons = () => (
    <div style={styles.buttonsContainer}>
      <div style={styles.statusLabel}>{this.renderStatusLabels()}</div>
      {this.show_Timer ? (
        <div style={styles.timer} ref="recordingTimer">
          00:00
        </div>
      ) : null}
      {this.renderPreviewPlayer()}
      <div style={[styles.row, styles.buttonsWrapper]}>
        {this.show_CancelBtn ? (
          <div style={[styles.cancelButton]}>
            <Icon icon="close" fill="#a1a5a8" size="1.2em" />
            <div onClick={this.cancelRecorded} style={styles.cancelButtonText}>
              Cancel
            </div>
          </div>
        ) : null}
        {this.show_StartBtn ? (
          <div
            style={[
              styles.startButtonText,
              this.state.noAudioResponseSupport ? styles.disabled : null
            ]}
            onClick={this.recordPressed}
          >
            Start
          </div>
        ) : null}
        {this.show_StopBtn ? (
          <div style={styles.stopButton} onClick={this.doneRecord}>
            <span style={styles.stopIcon} />
            Stop
          </div>
        ) : null}
      </div>

      {this.state.noAudioResponseSupport ? (
        <p style={styles.note}>Please visit using HTTPS:// for audio recording support</p>
      ) : null}
    </div>
  );

  renderProgressBar() {
    if (!this.show_ProgressBar) return null;
    let progressBarView = '';
    progressBarView = (
      <div style={styles.progressBarWrapper}>
        <progress ref="progressBar" value="0" style={styles.progressBar} />
        <p style={styles.fileSize}>
          File size: {window.constants.humanFileSize(this.state.uploadSize, true)}
        </p>
      </div>
    );
    return progressBarView;
  }

  renderOutBoxButtons = () => (
    <div style={styles.outBoxWrapper}>
      {this.show_BackButton || this.show_SubmitUploadedAudio || !this.disable_SubmitBtn ? (
        <div style={[styles.outBoxButtonsWrapper]}>
          <div
            style={[
              this.show_SubmitUploadedAudio || this.show_BackButton
                ? styles.retakeCancelBtns
                : styles.displayNone
            ]}
          >
            <div
              style={[
                styles.submitButton,
                styles.uploadSubmitButton,
                this.show_SubmitUploadedAudio ? null : styles.hideButton
              ]}
              key="submitUploaded"
              onClick={() => {
                this.uploadAudioFile(this.uploadedFile, true);
              }}
            >
              {this.props.totalSubmissions > 1 ? (
                <div style={styles.infoIconStyle}>
                  <Tooltip text="This will save your response. Note that you'll still have to submit the assignment.">
                    <Icon icon="info" fill="rgba(255, 255, 255, 0.68)" size="22px" />
                  </Tooltip>
                </div>
              ) : null}
              {this.props.totalSubmissions === 1 ? 'SUBMIT' : 'UPLOAD AUDIO'}
            </div>
            <div
              style={[styles.backButton, this.show_BackButton ? null : styles.hideButton]}
              key="back"
              onClick={this.cancelRecorded}
            >
              CANCEL
            </div>
          </div>
          <div
            style={[styles.deleteButton, !this.disable_SubmitBtn ? null : { display: 'none' }]}
            key="cancel"
            onClick={this.cancelRecorded}
          >
            CANCEL
          </div>
          <div
            onClick={this.submitAudio}
            style={[
              styles.submitButton,
              this.disable_SubmitBtn ? styles.disabledSubmitButton : null
            ]}
          >
            {this.props.totalSubmissions === 1 ? 'SUBMIT' : 'UPLOAD'}
          </div>
          {!this.disable_SubmitBtn && (
            <p style={styles.submitDownloadText}>
              {this.props.totalSubmissions === 1
                ? "As a precaution, this file will also be downloaded on submitting, so it's not lost due to network issues."
                : "As a precaution, this file will also be downloaded when you upload, so it's not lost due to network issues. Note that you'll still have to submit the assignment."}
            </p>
          )}
        </div>
      ) : null}

      {this.renderProgressBar()}
    </div>
  );

  isEnrolled = () => {
    if (!this.props.isEnrolled) {
      this.props.showEnrollDialog();
      return false;
    }
    return true;
  };

  startRecordButtonClicked = () => {
    this.setState({
      recordingAudio: false,
      recordedAudio: null,
      showingPreviewAudio: true
    });
  };

  uploadAudioFile = (file, uploadNow) => {
    const self = this;
    const fileName =
      user.id() +
      '_' +
      self.props.cardId +
      '_q' +
      self.props.position +
      'v' +
      0 +
      '_' +
      new Date().getTime() +
      '.' +
      file.name.split('.').pop();
    const s3Url = global.constants.s3LyearnAssetsUrl + fileName;

    analytics.track('FILE_UPLOAD_START', {
      fileName: s3Url
    });

    this.uploadedFile = file;
    this.uploadedFileObjectUrl = window.URL.createObjectURL(file);

    this.setState({
      uploadAudioPreview: true,
      responseToBeSubmitted: null
    });
    if (uploadNow !== true) return false;

    const uploadPromise = uploadToS3(s3Url, file, file.type, this.uploadProgress);
    this.setState({
      uploadingAudio: true,
      uploadSize: file.size
    });

    window.analytics.track('FILE_UPLOAD_COMPLETE', {
      fileName: s3Url
    });
    uploadPromise
      .then(data => {
        window.analytics.track('FILE_UPLOAD_COMPLETE', {
          fileName: s3Url
        });
        self.setState(
          {
            uploadAudioPreview: false,
            uploadingAudio: false,
            uploadSize: false,
            responseToBeSubmitted: s3Url
          },
          () => this.props.saveOneResponse(this.getResponse())
        );
        self.props.responseEnterChange(true);
      })
      .catch(reason => {
        SnackBarHelper.showSnackbar({
          label: 'File Upload failed, please try again.',
          status: 'error'
        });
        analytics.track('FILE_UPLOAD_FAILURE', {
          fileName: s3Url,
          error: reason && reason.toString && reason.toString(),
          stack: reason && reason.stack
        });
      });
  };

  fileUploaded = response => {
    if (!response.url) {
      SnackBarHelper.showSnackbar({
        label: 'File Upload failed, please try again.',
        status: 'error'
      });
      window.analytics.track('FILE_UPLOAD_FAILURE', {
        errorMessage: 'Filestack callback function does not contain url to uploaded file'
      });
      return false;
    }
    const url = response.url;
    TinyPubSub.unsubscribe('UserInteractionBlockChange');
    if (interactionsBlocked()) {
      TinyPubSub.subscribe(
        'UserInteractionBlockChange',
        (e, blocked) => !blocked && this.fileUploaded(response)
      );
      return false;
    }
    this.setState(
      {
        uploadAudioPreview: false,
        uploadingAudio: false,
        uploadSize: false,
        responseToBeSubmitted: url
      },
      () => this.props.saveOneResponse(this.getResponse())
    );
    this.props.responseEnterChange(true);
    return true;
  };

  fileUploadChange = type => () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    this.context.showLoading();
    let fromSources = [];
    if (type === 'upload') {
      fromSources = ['local_file_system', 'googledrive', 'audio'];
    } else if (type === 'record') {
      fromSources = ['audio', 'googledrive', 'local_file_system'];
    }
    window.fs_filepicker
      .picker({
        fromSources,
        maxFiles: 1,
        minFiles: 1,
        accept: [
          'audio/mpeg',
          'audio/mp3',
          'audio/wav',
          'audio/m4a',
          'audio/x-m4a',
          'audio/*',
          'video/mp4'
        ],
        onOpen: () => {
          this.context.hideLoading();
        },
        onFileUploadFailed: (file, error) => {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FAILED', {
            cardId: this.props.cardId,
            recordOrUpload: type,
            error
          });
        },
        onFileUploadFinished: data => {
          try {
            this.fileUploaded(data);
          } catch (e) {
            console.error(e);
          }
        }
      })
      .open();
  };

  fileUploadChangeWithoutPicker = () => {
    analytics.track('FILE_SELECTED_TO_BE_UPLOADED', {
      card_name: this.props.cardName,
      card_id: this.props.cardId,
      question_index: this.props.position,
      type: 'video'
    });
    this.setState({
      uploadError: false,
      uploadFileSizeError: false
    });
    const audioUploader = this.refs.audioUploader;
    const uploadFile = audioUploader.files[0];
    if (!uploadFile) {
      return false;
    }
    const fileSize = uploadFile.size / (1000 * 1000);
    if (fileSize > 500) {
      this.setState({
        uploadFileSizeError: {
          error: true,
          text: 'Uploaded File size is ' + fileSize.toFixed(0) + ' MB. It must be less then 500 MB'
        }
      });
      return false;
    }
    const extension = uploadFile.name
      .split('.')
      .pop()
      .toLowerCase();
    if (['mp3', 'wav', 'm4a'].indexOf(extension) > -1) {
      audioUploader.value = null;
      this.uploadAudioFile(uploadFile);
    } else {
      console.log('fileupload:: ', 'INVALID FILE FORMAT');
      this.setState({
        uploadError: true
      });
    }
  };

  renderModeSelectButtons() {
    if (!this.show_ModeSelector) return null;
    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    return (
      <div style={styles.initialButtons}>
        <div
          style={[styles.initialBtn, styles.optRecordVideo]}
          onClick={
            useFilestackFilePicker
              ? this.fileUploadChange('record')
              : () => showVideoResponse(this.props.cardId, this.fileUploaded, 'audio-record')
          }
        >
          <div style={[styles.initialBtnIcon, styles.recordIcon]} />
          <div style={styles.optIconsText}>RECORD AUDIO</div>
        </div>
        <div
          style={[styles.initialBtn, styles.optRecordVideo]}
          onClick={
            useFilestackFilePicker
              ? this.fileUploadChange('upload')
              : () => showVideoResponse(this.props.cardId, this.fileUploaded, 'audio-upload')
          }
        >
          <Icon
            icon="upload-to-cloud"
            viewBox="0 0 32 22"
            fill="#0ABFF1"
            size="32px"
            style={styles.cloudIcon}
          />
          <div style={styles.optIconsText}>Upload AUDIO</div>
        </div>
      </div>
    );
  }

  renderErrors = () => (
    <div style={styles.errorTextWrapper}>
      {this.state.uploadError && !this.state.recordingAudio && !this.state.uploadingAudio ? (
        <p style={styles.uploadError}>
          Please upload only <span style={styles.strong}>MP3</span> or{' '}
          <span style={styles.strong}>WAV</span> format
        </p>
      ) : null}
      {this.state.uploadFileSizeError &&
      !this.state.recordingAudio &&
      !this.state.uploadingAudio ? (
        <p style={styles.uploadError}>{this.state.uploadFileSizeError.text}</p>
      ) : null}
    </div>
  );

  statesHelper = () => {
    const state = this.state;
    this.show_ModeSelector =
      !this.props.response &&
      (!state.recordingAudio &&
        !state.recordedAudio &&
        !state.showingPreviewAudio &&
        !state.uploadAudioPreview &&
        !state.uploadingAudio &&
        (!state.responseToBeSubmitted || state.responseToBeSubmitted === ''));
    this.show_StartBtn = !state.recordingAudio && !state.recordedAudio;
    this.show_CancelBtn = state.recordingAudio;
    this.show_sineWave = state.recordingAudio;
    this.show_StopBtn = state.recordingAudio && !state.recordedAudio;
    this.show_Timer = true;
    this.disable_SubmitBtn =
      state.recordingAudio || !state.audioSubmissible || state.uploadingAudio;
    this.show_ProgressBar = state.uploadingAudio;
    this.show_InBoxButtons = !state.uploadingAudio && state.showingPreviewAudio;
    this.show_SubmitUploadedAudio =
      state.uploadAudioPreview && this.uploadedFile && !state.uploadingAudio;
    this.show_BackButton =
      this.disable_SubmitBtn &&
      !state.uploadingAudio &&
      (state.showingPreviewAudio || state.uploadAudioPreview);
  };

  showTroublePopup = () => {
    this.context.showTroublePopup(true, 'AUDIO');
  };

  render() {
    this.statesHelper();
    const response = this.state.responseToBeSubmitted || this.props.response;
    return (
      <div className={`audioRecorder${this.props.questionId}`}>
        {this.show_ModeSelector ? <div style={styles.previewLable}>YOUR RESPONSE</div> : null}
        {this.renderModeSelectButtons()}
        {this.renderPlayer()}
        {this.props.isResponseEntered && response && response !== '' ? null : this.renderButtons()}
        {this.renderErrors()}
        <div className="troubleLink">
          <span onClick={this.showTroublePopup}>Having trouble recording?</span>
        </div>
      </div>
    );
  }
}

const styles = {
  wrapper: {},
  boxContainer: {
    padding: '20px',
    border: '1px solid #dbe2e8',
    position: 'relative'
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  statusLabel: {
    color: '#767e86',
    fontSize: '14px',
    textAlign: 'center'
  },
  outBoxButtonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 10px 10px'
  },
  deleteButton: {
    position: 'relative',
    display: 'block',
    padding: '17px 35px',
    minWidth: '100px',
    textAlign: 'center',
    color: '#767e86',
    cursor: 'pointer',
    margin: '10px 10px 10px',
    fontWeight: '500',
    fontSize: '13px'
  },
  submitButton: {
    position: 'relative',
    cursor: 'pointer',
    padding: '17px 20px',
    minWidth: '248px',
    background: '#42c4e3',
    color: '#fff',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '13px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '2px',
    ':hover': {
      background: '#40ACC5'
    },
    ':active': {
      background: '#2C7587'
    }
  },
  disabledSubmitButton: {
    display: 'none',
    background: '#c8cfd6',
    cursor: 'auto'
  },
  startButtonText: {
    width: '148px',
    height: '44px',
    fontWeight: '500',
    cursor: 'pointer',
    textAlign: 'center',
    backgroundColor: '#0abff1',
    textTransform: 'uppercase',
    fontSize: '12px',
    letterSpacing: '0.1px',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cancelButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '5px',
    right: '5px',
    cursor: 'pointer'
  },
  cancelButtonText: {
    textTransform: 'uppercase',
    fontSize: '12px',
    letterSpacing: '0.1px',
    fontWeight: '500',
    color: '#a1a5a8'
  },
  stopButton: {
    border: '1px solid #979797',
    width: '148px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  stopIcon: {
    width: '12px',
    height: '12px',
    backgroundColor: '#0abff1',
    marginRight: '4px'
  },
  disabled: {
    cursor: 'default',
    opacity: '0.4'
  },
  buttonContainer: {
    margin: '0px 15px 0px 0px'
  },
  buttonsWrapper: {
    justifyContent: 'center'
  },
  timer: {
    textAlign: 'center',
    fontSize: '36px',
    padding: '10px 10px 10px',
    lineHeight: '1.2em',
    color: '#767e86',
    fontWeight: '500'
  },
  container: {
    padding: '20px 0px',
    maxWidth: '477px'
  },
  uploadedAudioContainer: {
    padding: '20px 0 0',
    maxWidth: '477px'
  },
  miniPlayerContainer: {
    width: '238px',
    margin: '0 auto',
    padding: '5px 10px'
  },
  previewLable: {
    color: '#9ea7b1',
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    padding: '0 0 16px 0'
  },
  note: {
    color: '#DF4E4E',
    padding: '10px 5px',
    fontSize: '14px',
    textAlign: 'center'
  },
  progressBar: {
    width: '80%',
    margin: '0 auto',
    display: 'block'
  },
  fileSize: {
    textAlign: 'center',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.8)'
  },
  audioUploadInput: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: '-1'
  },
  infoIconStyle: {
    padding: '0px',
    position: 'absolute',
    top: '4px',
    right: '3px',
    height: 'auto',
    width: 'auto',
    border: 'none'
  },
  initialButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  initialBtn: {
    backgroundColor: 'rgba(219, 226, 232, 0.24)',
    border: '1px solid rgba(118,126,134,0.24)',
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '42.35%',
    boxSizing: 'border-box',
    padding: '16px 1% 12px',
    cursor: 'pointer'
  },
  opeUploadAudio: {
    cursor: 'pointer'
  },
  cloudIcon: {
    margin: '0px auto -6px auto',
    display: 'block'
  },
  recordIcon: {
    height: '22px',
    width: '22px',
    backgroundColor: '#0ABFF1',
    borderRadius: '50%'
  },
  optIconsText: {
    marginTop: '12px',
    fontSize: '13px',
    letterSpacing: '1px',
    color: '#767e86',
    textTransform: 'uppercase',
    fontWeight: '500'
  },
  backButton: {
    position: 'relative',
    display: 'block',
    padding: '14px 20px',
    minWidth: '80px',
    textAlign: 'center',
    color: '#767e86',
    cursor: 'pointer',
    margin: '10px 10px 0',
    fontWeight: '500',
    fontSize: '13px'
  },
  hideButton: {
    position: 'absolute',
    top: '-7000px',
    left: '-7000px',
    visibility: 'hidden'
  },
  retakeCancelBtns: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 0 10px'
  },
  uploadSubmitButton: {
    marginTop: '10px'
  },
  displayNone: {
    display: 'none'
  },
  uploadError: {
    padding: '7px 0px 10px 0px',
    color: '#C00E0E',
    textAlign: 'center'
  },
  errorTextWrapper: {
    display: 'flex',
    marginTop: '10px',
    justifyContent: 'center'
  },
  progressBarWrapper: {
    display: 'flex',
    marginTop: '10px',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  canvasStyle: {
    width: '400px',
    margin: '0 auto',
    display: 'block'
  },
  submitDownloadText: {
    textAlign: 'center',
    fontSize: '14px',
    maxWidth: '80%',
    padding: '15px 0px 0px',
    color: '#666'
  },
  apologyContainer: {
    padding: '5px 7px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: '100%'
  },
  alertIcon: {
    height: '18px',
    width: '18px',
    marginRight: '5px'
  }
};

export default AudioResponse;
